module.exports = __webpack_public_path__ + "static/media/BlaineBurnham.7468136b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2019-speakers/BlaineBurnham.png
// module id = 834
// module chunks = 0